<div class="icon-branding">
  @if (productResourceful) {
    <svg-icon src="/assets/logo/resourceful-with-tag.svg"></svg-icon>
  }
  @if (productPurposeful) {
    <svg-icon src="/assets/logo/purposeful-with-tag.svg"></svg-icon>
  }
</div>
